import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { FOODIE_ACCESS_SERVICE } from '../EndPoints';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetAccessCodeById = createAsyncThunk('accessCode/getAccessCodeById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${FOODIE_ACCESS_SERVICE.getAccessCodeById}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateAccessCode = createAsyncThunk("accessCode/createAccessCode",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(FOODIE_ACCESS_SERVICE.createAccessCode, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetAccessCodeQR = createAsyncThunk('accessCode/getAccessCodeQR ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${FOODIE_ACCESS_SERVICE.getAccessCodeQR}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const CancelAccessCode = createAsyncThunk("accessCode/cancelAccessCode",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(FOODIE_ACCESS_SERVICE.cancelAccessCode, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
